import { To, useLocation, useNavigate } from 'react-router'

export const useGoBack = (fallback: To) => {
  const navigate = useNavigate()
  const location = useLocation()
  const canGoBack = location.key !== 'default'
  return () => {
    if (canGoBack) {
      navigate(-1)
    } else {
      navigate(fallback)
    }
  }
}
